<template>
  <div class="w-screen max-w-[1220px] mx-auto px-5"><slot /></div>
</template>
